import {
    Component,
    TemplateRef,
    ViewChild,
    OnInit,
    EventEmitter,
    Output,
    NgZone,
    ChangeDetectorRef
} from '@angular/core';
import { NgbModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgForm, FormsModule } from '@angular/forms';
import {ApiResponse, Taxe, TaxeService} from '../taxe.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-croud-taxe',
  templateUrl: './croud-taxe.component.html',
  styleUrls: ['./croud-taxe.component.scss'],
  standalone: true,
  imports: [CommonModule, FormsModule]
})
export class CroudTaxeComponent implements OnInit {
  @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
  @Output() TaxeAdded = new EventEmitter<Taxe>();
  @Output() TaxeUpdated = new EventEmitter<Taxe>();
  private modalRef: NgbModalRef | null = null;
    originalStatut: boolean | null = null;
  modalType: 'ajouter' | 'update' | 'etat' = 'ajouter';
  isLoading: boolean = false;
  TaxeData: Taxe = {
    id: 0,
    client_id: 1,
    station_id: 1,
    nom: '',
    label: '',
    valeur: 1,
    valeur_fixe: false,
    valeur_pourcentage: true,
    applique_avant_tva: false,
    applique_apres_tva: false,
    taxe_applique_sur_produits: false,
    type: '+',
    applique_sur_product: false,
    applique_sur_tous_document: false,
    utilisation_tous: true,
    utilisation_vente: false,
    utilisation_achat: false,
    statut: true
  };
  newStatut: boolean | null = null;
  confirmationMessage: string | null = null;
  stationId: number | null = null;
  clientId: number | null = null;
    desiredStatut: boolean | null = null;
    TaxeList: Taxe[] = [];
    togglingTaxeId: number | null = null;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private TaxeService: TaxeService ,   private ngZone: NgZone ,   private cdr: ChangeDetectorRef
  ) {

  }

  ngOnInit(): void {

  //  this.loadUserData();
  }

  loadUserData(): void {
    const user = localStorage.getItem('currentUser');
    if (user) {
      try {
        const currentUser = JSON.parse(user);
        if (currentUser?.stations?.length > 0) {
          this.stationId = currentUser.stations[0].id;
          this.clientId = currentUser.id;
          this.TaxeData.station_id = this.stationId;
          this.TaxeData.client_id = this.clientId;
          //console.log('CroudTaxeComponent: Station ID set:', this.stationId, 'Client ID:', this.clientId);
        } else {
          this.toastr.error('Aucune station trouvée. Veuillez créer une station.', 'Erreur');
          console.error('CroudTaxeComponent: No stations found in currentUser');
        }
      } catch (error) {
        this.toastr.error('Erreur lors de la lecture des données utilisateur.', 'Erreur');
        console.error('CroudTaxeComponent: Error parsing currentUser:', error);
      }
    } else {
      this.toastr.error('Utilisateur non connecté.', 'Erreur');
      console.error('CroudTaxeComponent: No currentUser in localStorage');
    }
  }

  openModal(type: 'ajouter' | 'update' | 'etat' = 'ajouter', taxe?: Taxe, statut?: boolean): void {

    this.modalType = type;
    this.resetForm();

    if (type === 'update' || type === 'etat') {
      if (taxe) {
        this.TaxeData = { ...taxe, client_id: this.clientId || 1, station_id: this.stationId || 1 };
        if (type === 'etat') {
          this.newStatut = statut !== undefined ? statut : !this.TaxeData.statut;
          this.confirmationMessage = `Êtes-vous sûr de vouloir ${this.newStatut ? 'activer' : 'désactiver'} la taxe ${this.TaxeData.nom} (${this.TaxeData.valeur}${this.TaxeData.valeur_pourcentage ? '%' : ' TND'}) ?`;
        }
      }
    }

    const options: NgbModalOptions = {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    };
    try {
      this.modalRef = this.modalService.open(this.modalTemplate, options);
      console.log('CroudTaxeComponent: Modal opened successfully for type:', type);
    } catch (error) {
      console.error('CroudTaxeComponent: Error opening modal:', error);
      this.toastr.error('Erreur lors de l\'ouverture du modal', 'Erreur');
    }
  }

  resetForm(): void {
    this.TaxeData = {
      id: 0,
      client_id: this.clientId || 1,
      station_id: this.stationId || 1,
      nom: '',
      label: '',
      valeur: 1,
      valeur_fixe: false,
      valeur_pourcentage: true,
      applique_avant_tva: false,
      applique_apres_tva: false,
      taxe_applique_sur_produits: false,
      type: '+',
      applique_sur_product: false,
      applique_sur_tous_document: false,
      utilisation_tous: true,
      utilisation_vente: false,
      utilisation_achat: false,
      statut: true
    };
    this.newStatut = null;
    this.confirmationMessage = null;
  }

  cancelModal(): void {
   // this.toastr.info('Action annulée', 'Information');
    this.isLoading = false;
    if (this.modalRef) {
      this.modalRef.dismiss('Cancel click');
      this.modalRef = null;
      console.log('CroudTaxeComponent: Modal dismissed');
    }
  }

    onSubmit(form: any): void {
        if (this.stationId === null) {
            this.toastr.error('Aucune station disponible.', 'Erreur');
            console.error('ParametreTaxeComponent: No stationId available');
            return;
        }

        if (!form.valid && this.modalType !== 'etat') {
            this.toastr.error('Veuillez remplir tous les champs requis.', 'Erreur');
            console.warn('ParametreTaxeComponent: Form is invalid:', form.errors, 'Controls:', form.controls);
            return;
        }

        const taxe = { ...this.TaxeData };
        console.log('ParametreTaxeComponent: Submitting Taxe:', taxe);

        if (this.modalType === 'etat' && this.TaxeData.id !== 0) {
            if (this.desiredStatut === null || this.desiredStatut === this.originalStatut) {
                this.toastr.warning('Aucun changement détecté pour le statut.', 'Avertissement');
                this.modalRef!.close();
                this.modalRef = null;
                this.resetForm();
                return;
            }
            const taxeIndex = this.TaxeList.findIndex(t => t.id === this.togglingTaxeId);
            if (taxeIndex !== -1) {
                this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.desiredStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
                this.ngZone.run(() => {
                    this.cdr.detectChanges();

                });
            }

            const updatedTaxe = { ...this.TaxeData, statut: this.desiredStatut };
            this.TaxeService.updateTaxe(updatedTaxe, this.stationId).subscribe({
                next: (response: ApiResponse) => {
                    console.log('ParametreTaxeComponent: Update Taxe response:', response);
                    if (response.success) {
                        if (response.taxes && Array.isArray(response.taxes)) {
                            response.taxes.forEach(taxe => this.updateTaxeList(taxe));
                        } else if (response.taxe) {
                            this.updateTaxeList(response.taxe);
                        } else {
                            if (taxeIndex !== -1) {
                                this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.desiredStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
                            }
                        }
                        this.ngZone.run(() => {
                            this.cdr.detectChanges();

                            this.toastr.success(`Taxe ${updatedTaxe.statut ? 'activée' : 'désactivée'} avec succès`, 'Succès');
                        });
                        this.modalRef!.close('Accept click');
                        this.modalRef = null;
                    } else {
                        this.toastr.error('Échec du changement de statut de la taxe: ' + (response.message || 'Erreur inconnue'), 'Erreur');
                        console.error('ParametreTaxeComponent: Update Taxe response unsuccessful:', response);
                        if (taxeIndex !== -1) {
                            this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.originalStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
                            this.ngZone.run(() => {
                                this.cdr.detectChanges();

                            });
                        }
                    }
                },
                error: (error) => {
                    this.toastr.error('Erreur lors du changement de statut: ' + (error.message || 'Erreur inconnue'), 'Erreur');
                    console.error('ParametreTaxeComponent: Update status error:', error);
                    const taxeIndex = this.TaxeList.findIndex(t => t.id === this.togglingTaxeId);
                    if (taxeIndex !== -1) {
                        this.TaxeList = [...this.TaxeList.slice(0, taxeIndex), { ...this.TaxeList[taxeIndex], statut: this.originalStatut || false }, ...this.TaxeList.slice(taxeIndex + 1)];
                        this.ngZone.run(() => {
                            this.cdr.detectChanges();

                        });
                    }
                }
            });
            this.resetForm();
        } else if (this.modalType === 'ajouter') {
            this.TaxeService.createTaxe(taxe, this.stationId).subscribe({
                next: (response: ApiResponse) => {
                    console.log('ParametreTaxeComponent: Create Taxe response:', JSON.stringify(response, null, 2));
                    if (response.success) {
                        if (response.taxes && Array.isArray(response.taxes)) {
                            response.taxes.forEach(taxe => this.updateTaxeList(taxe));
                        } else if (response.taxe) {
                            this.updateTaxeList(response.taxe);
                        } else {
                            this.toastr.error('Réponse inattendue du serveur: aucun taxe retourné.', 'Erreur');
                            console.error('ParametreTaxeComponent: Create Taxe response unexpected:', response);
                        }
                        this.ngZone.run(() => {
                            this.cdr.detectChanges();

                            this.toastr.success('Taxe ajoutée avec succès', 'Succès');
                        });
                        this.modalRef!.close('Accept click');
                        this.modalRef = null;
                    } else {
                        this.toastr.error('Échec de l\'ajout de la taxe: ' + (response.message || 'Réponse inattendue'), 'Erreur');
                        console.error('ParametreTaxeComponent: Create Taxe response unsuccessful:', JSON.stringify(response, null, 2));
                    }
                },
                error: (error) => {
                    this.toastr.error('Erreur lors de l\'ajout: ' + (error.message || 'Erreur inconnue'), 'Erreur');
                    console.error('ParametreTaxeComponent: Create error:', error);
                }
            });
        } else if (this.modalType === 'update' && this.TaxeData.id !== 0) {
            const originalTaxe = this.TaxeList.find(t => t.id === this.TaxeData.id);
            if (originalTaxe && JSON.stringify(originalTaxe) === JSON.stringify(taxe)) {
                this.toastr.warning('Aucun changement détecté pour la mise à jour.', 'Avertissement');
                this.modalRef!.close();
                this.modalRef = null;
                return;
            }
            this.TaxeService.updateTaxe(taxe, this.stationId).subscribe({
                next: (response: ApiResponse) => {
                    console.log('ParametreTaxeComponent: Update Taxe response:', response);
                    if (response.success) {
                        if (response.taxes && Array.isArray(response.taxes)) {
                            response.taxes.forEach(taxe => this.updateTaxeList(taxe));
                        } else if (response.taxe) {
                            this.updateTaxeList(response.taxe);
                        } else {
                            this.toastr.error('Réponse inattendue du serveur: aucun taxe mis à jour.', 'Erreur');
                            console.error('ParametreTaxeComponent: Unexpected response format:', response);
                        }
                        this.ngZone.run(() => {
                            this.cdr.detectChanges();

                            this.toastr.success('Taxe mise à jour avec succès', 'Succès');
                        });
                        this.modalRef!.close('Accept click');
                        this.modalRef = null;
                    } else {
                        this.toastr.error('Échec de la mise à jour de la taxe: ' + (response.message || 'Erreur inconnue'), 'Erreur');
                        console.error('ParametreTaxeComponent: Update Taxe response unsuccessful:', response);
                    }
                },
                error: (error) => {
                    this.toastr.error('Erreur lors de la mise à jour: ' + (error.message || 'Erreur inconnue'), 'Erreur');
                    console.error('ParametreTaxeComponent: Update error:', error);
                }
            });
        }
    }

    private updateTaxeList(updatedTaxe: Taxe): void {
        const index = this.TaxeList.findIndex(t => t.id === updatedTaxe.id);
        if (index !== -1) {
            this.TaxeList = [
                ...this.TaxeList.slice(0, index),
                { ...this.TaxeList[index], ...updatedTaxe },
                ...this.TaxeList.slice(index + 1)
            ];
        } else {
            this.TaxeList = [...this.TaxeList, updatedTaxe];
        }
        this.ngZone.run(() => {
            this.cdr.detectChanges();

        });
    }

  incrementValue(): void {
    this.TaxeData.valeur = (this.TaxeData.valeur || 1) + 1;
  }

  decrementValue(): void {
    if (this.TaxeData.valeur > 0) {
      this.TaxeData.valeur -= 1;
    }
  }
}